import React, { useState, useEffect } from 'react';
import ReactAudioPlayer from 'react-audio-player';

const Sentence = (props) => {
    const [obj, setObj] = useState([]);
    const [url, setUrl] = useState([]);
    const [questionTitle, setQuestionTitle] = useState([]);

    const [questionId, setQuestionId] = useState([]);
    const onClick = () => {
        window.location.href = "/admin/editquestiondetails/" + questionId + "/sentence";
    }

    useEffect(() => {
        setQuestionId(JSON.parse(props.data.id));
        let title = JSON.parse(props.data.contentStr)

        setQuestionTitle(title['text'].split('\n')[0])
        setObj(JSON.parse(props.data.contentStr))
        setUrl(JSON.parse(props.data.contentStr)['url']);
    }, []);

    return (
        <div>
            <hr />
            <div style={{ alignItems: "center", textAlign: "center" }}>
                <b>Sentence Sorusu</b>

                {obj['type'] === "sound" ? (
                    <ReactAudioPlayer
                        src={url}
                        controls
                    />
                ) : (
                    <div></div>
                )}
                {obj['type'] === "video" ? (
                    <video
                        width="640"
                        height="360"
                        controls
                        autoPlay={false}  // autoplay'i false yapıyoruz
                    >
                        <source src={url} type="video/mp4" />
                        Tarayıcınız video etiketini desteklemiyor.
                    </video>
                ) : (
                    <div></div>
                )}
                {obj['type'] === "image" ? (
                    <div style={{ width: "70%", marginLeft: "auto", marginRight: "auto " }}>
                        <img style={{ width: "200px" }} src={url} />
                    </div>
                ) : (
                    <div></div>
                )}
                {obj['type'] === "image_sound" ? (
                    <div>
                        <img style={{ width: "200px" }} src={obj['url']} />

                        <br />
                        <ReactAudioPlayer
                            src={obj['soundUrl']}
                            controls
                        />
                    </div>
                ) : (
                    <div></div>
                )}


            </div>
            <div class="d-flex justify-content-center" style={{ fontSize: 40, alignItems: "center", textAlign: "center", alignContent: "center", flexDirection: "column" }}>
                <div>
                    <h6 style={{ fontSize: 22 }}>
                        {questionTitle}
                    </h6>
                </div>
                <div>
                    <h6>
                        soru detayı için düzenleye giriniz!
                    </h6>
                </div>

            </div>

            <div className='d-flex justify-content-center'>
                <button className='btn btn-info' onClick={onClick}>Soruyu Düzenle</button>
            </div>
        </div>
    );
};

export default Sentence;